module.exports = "/assets/fa91376508ed3c051892db2c45c7f3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WY.png
// module id = 1977
// module chunks = 0